export default "__VITE_ASSET__DHo7nMqu__"